import React from 'react'
import { bool, string, func } from 'prop-types'

import { Checkbox } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DiscountPanel from './DiscountPanel'

function BoostEarnings({
  participateAll,
  regularDiscount,
  superDiscount,
  handleParticipateAllChange,
  handleRegularDiscountChange,
  handleSuperDiscountChange,
}) {
  return (
    <section>
      <h2 className="cgt-legacy-heading-h5">Boost your earnings</h2>
      <p>
        Designers who participate in discount programs can see up to 50% more
        total revenue on average.
      </p>

      <div className="sales-form__settings-container">
        <Checkbox
          checkedColor="primary"
          id="checkbox-story"
          label="I want to participate in all available programs"
          isChecked={participateAll}
          onChange={handleParticipateAllChange}
          isControlled
        />
        <div className="sales-form__note-text">
          Note: You must select this option for your models to be included in
          site-wide sales and promotions.
        </div>

        <DiscountPanel
          participateAll={participateAll}
          regularDiscount={regularDiscount}
          superDiscount={superDiscount}
          onRegularDiscountChange={handleRegularDiscountChange}
          onSuperDiscountChange={handleSuperDiscountChange}
        />
      </div>
    </section>
  )
}

BoostEarnings.propTypes = {
  participateAll: bool.isRequired,
  regularDiscount: string.isRequired,
  superDiscount: string.isRequired,
  handleParticipateAllChange: func.isRequired,
  handleRegularDiscountChange: func.isRequired,
  handleSuperDiscountChange: func.isRequired,
}

export default BoostEarnings
